import React from "react";
import { useNavigate } from 'react-router-dom';

export default function SettingsMain(){
    const navigate = useNavigate();

    const handleLogOut = () => {
      localStorage.removeItem("userAuthentication");
      localStorage.removeItem("userId");
      localStorage.removeItem('ACCESS')
      localStorage.removeItem('locationId')
      localStorage.removeItem('kitchenId')
      navigate("/login");
    };
    return(
        <a onClick={handleLogOut} href="/" >
            keluar
        </a>
    )
}